// NOTES:
// - Consider using `font-display` (https://developers.google.com/web/updates/2016/02/font-display)

const fontPreloadHeaders = [
  'Link: </fonts/RidleyGroteskExtraBold.woff2>; rel=preload; as=font; crossorigin',
  'Link: </fonts/RidleyGroteskExtraBoldItalic.woff2>; rel=preload; as=font; crossorigin',
  'Link: </fonts/RidleyGroteskMedium.woff2>; rel=preload; as=font; crossorigin',
  'Link: </fonts/RidleyGroteskLight.woff2>; rel=preload; as=font; crossorigin',
  'Link: </fonts/TungstenMedium.woff>; rel=preload; as=font; crossorigin',
  'Link: <https://fonts.gstatic.com/s/sourceserifpro/v5/neIQzD-0qpwxpaWvjeD0X88SAOeauXQ-oA.woff2>; rel=preload; as=font; crossorigin',
]

// Use it if we can't use H2 push
const fontPreloads = [
  // {
  //   // proxima-nova 400
  //   rel: 'preload',
  //   as: 'font',
  //   type: 'font/woff2',
  //   crossorigin: 'anonymous',
  //   href:
  //     'https://use.typekit.net/af/705e94/00000000000000003b9b3062/27/l?primer=e6066692ab328d1a92bb155659ed6609b693e1e352f0e8982e4224719b13bdfb&fvd=n4&v=3',
  // },
]

const fontStyleSheets = [
  {
    rel: 'stylesheet',
    href: '/fonts/weather-icons.css',
  },
]

const fontFaces = [
  {
    '@font-face': {
      fontFamily: 'RidleyGrotesk',
      fontStyle: 'normal',
      fontWeight: 800,
      src: `url("/fonts/RidleyGroteskExtraBold.woff2") format("woff2"),
            url("/fonts/RidleyGroteskExtraBold.woff") format("woff")`,
    },
  },
  {
    '@font-face': {
      fontFamily: 'RidleyGrotesk',
      fontStyle: 'italic',
      fontWeight: 800,
      src: `url("/fonts/RidleyGroteskExtraBoldItalic.woff2") format("woff2"),
            url("/fonts/RidleyGroteskExtraBoldItalic.woff") format("woff")`,
    },
  },
  {
    '@font-face': {
      fontFamily: 'RidleyGrotesk',
      fontStyle: 'normal',
      fontWeight: 500,
      src: `url("/fonts/RidleyGroteskMedium.woff2") format("woff2"),
            url("/fonts/RidleyGroteskMedium.woff") format("woff")`,
    },
  },
  {
    '@font-face': {
      fontFamily: 'RidleyGrotesk',
      fontStyle: 'normal',
      fontWeight: 300,
      src: `url("/fonts/RidleyGroteskLight.woff2") format("woff2"),
            url("/fonts/RidleyGroteskLight.woff") format("woff")`,
    },
  },
  {
    '@font-face': {
      fontFamily: 'TungstenMedium',
      fontStyle: 'normal',
      fontWeight: 'normal',
      src: `url("/fonts/TungstenMedium.woff") format("woff")`,
    },
  },
  {
    '@font-face': {
      fontFamily: 'DinosaurBoldItalic',
      fontStyle: 'italic',
      fontWeight: 700,
      src: `url("/fonts/DinosaurBoldItalic.woff2") format("woff2"),
            url("/fonts/DinosaurBoldItalic.woff") format("woff")`,
    },
  },
  {
    /* latin-ext */
    '@font-face': {
      fontFamily: 'SourceSerifPro',
      fontStyle: 'normal',
      fontWeight: 400,
      src:
        "local('Source Serif Pro'), local('SourceSerifPro-Regular'), url(https://fonts.gstatic.com/s/sourceserifpro/v5/neIQzD-0qpwxpaWvjeD0X88SAOeauXo-oBOL.woff2) format('woff2')",
      unicodeRange:
        'U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF',
    },
  },
  {
    /* latin */
    '@font-face': {
      fontFamily: 'SourceSerifPro',
      fontStyle: 'normal',
      fontWeight: 400,
      src:
        "local('Source Serif Pro'), local('SourceSerifPro-Regular'), url(https://fonts.gstatic.com/s/sourceserifpro/v5/neIQzD-0qpwxpaWvjeD0X88SAOeauXQ-oA.woff2) format('woff2')",
      unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
    },
  },
  {
    /* latin-ext */
    '@font-face': {
      fontFamily: 'SourceSerifPro',
      fontStyle: 'normal',
      fontWeight: 700,
      src:
        "local('Source Serif Pro Bold'), local('SourceSerifPro-Bold'), url(https://fonts.gstatic.com/s/sourceserifpro/v6/neIXzD-0qpwxpaWvjeD0X88SAOeasc8btSKqxKcsdrOPbQ.woff2) format('woff2')",
      unicodeRange:
        'U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF',
    },
  },
  {
    /* latin */
    '@font-face': {
      fontFamily: 'SourceSerifPro',
      fontStyle: 'normal',
      fontWeight: 700,
      src:
        "local('Source Serif Pro Bold'), local('SourceSerifPro-Bold'), url(https://fonts.gstatic.com/s/sourceserifpro/v6/neIXzD-0qpwxpaWvjeD0X88SAOeasc8btSyqxKcsdrM.woff2) format('woff2')",
      unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
    },
  },
]

module.exports = {
  fontPreloadHeaders,
  fontPreloads,
  fontStyleSheets,
  fontFaces,
}
